<script setup lang="ts">
    import type { Schemas } from '#shopware';

    defineProps<{
        order: Schemas['Order'];
    }>();

    defineOptions({ name: 'AccountOrder' });

    const { t } = useI18n();

    const isExpand = ref(false);
    const toggleView = () => (isExpand.value = !isExpand.value);

    const formatDate = (date: Date | string) =>
        new Date(date).toLocaleDateString((typeof navigator !== 'undefined' && navigator.language) || 'en-US');
</script>

<template>
    <div class="account-order">
        <AccountOrderSummary>
            <div class="number-value">
                {{ order?.orderNumber }}
            </div>
            <div class="total-value">
                <SharedPrice
                    v-if="order?.amountTotal"
                    :value="order.amountTotal"
                    data-testid="order-subtotal"
                />
            </div>
            <div
                v-if="order?.orderDate"
                class="date-value"
            >
                {{ formatDate(order.orderDate) }}
            </div>
            <div class="status-value">
                {{ order.stateMachineState.name }}
            </div>
            <button
                :aria-expanded="isExpand"
                @click="toggleView"
            >
                {{ !isExpand ? t('checkout.processing.show') : t('checkout.processing.hide') }}
            </button>
        </AccountOrderSummary>
        <AccountOrderDetails
            v-if="isExpand"
            :order-id="order.id"
        />
    </div>
</template>

<style lang="scss" scoped>
    .account-order {
        margin-bottom: $spacing;
    }
</style>
